import { jsx } from "react/jsx-runtime";
import { forwardRef } from "react";
import { createSvgIcon } from "@mui/material";
const Icon = () => /* @__PURE__ */ jsx("svg", { xmlns: "http://www.w3.org/2000/svg", fill: "none", children: /* @__PURE__ */ jsx(
  "path",
  {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M12 12.17 8.83 9l-1.41 1.41L12 15l4.59-4.59L15.17 9z",
    clipRule: "evenodd"
  }
) });
const BaseSvgIcon = createSvgIcon(Icon(), "ArrowDown");
function ArrowDown({ width, height, sx, ...props }, ref) {
  return /* @__PURE__ */ jsx(
    BaseSvgIcon,
    {
      ref,
      viewBox: "0 0 24 24",
      sx: {
        width,
        height: height || width,
        ...sx
      },
      ...props
    }
  );
}
const ArrowDown$1 = forwardRef(ArrowDown);
export {
  ArrowDown$1 as A
};
